import svgToTinyDataUri from '../svg-to-mini-data-uri';

const createPropertyTaxIcon = (fill: string) =>
  svgToTinyDataUri(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="${fill}">
  <path d="M440-200h80v-40h40q17 0 28.5-11.5T600-280v-120q0-17-11.5-28.5T560-440H440v-40h160v-80h-80v-40h-80v40h-40q-17 0-28.5 11.5T360-520v120q0 17 11.5 28.5T400-360h120v40H360v80h80v40ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-560v-160H240v640h480v-480H520ZM240-800v160-160 640-640Z"/>
</svg>`,
  );

export const propertyTaxIcon = createPropertyTaxIcon('#2B2A35');
export const propertyTaxIconCurrentColor = createPropertyTaxIcon('var(--fill-0, currentColor)');
